import { validateEmail } from '../common'
import { newsletter } from '../main/newsletter'

class BackInStockForm extends HTMLElement {
  constructor () {
    super()
    this.btn_spinner = this.querySelector('.icon--activity-spinning')
    this.btn_label = this.querySelector('.bis__btn-label')
    this.input = this.querySelector('.bis__input')
    this.input.addEventListener('blur', this.hideMessage.bind(this))
    this.form = this.querySelector('form')
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.email_error = this.querySelector('.bis__email-error-msg')
    this.server_error = this.querySelector('.bis__server-error-msg')
    this.success_msg = this.querySelector('.bis__success-msg')
    this._observers = []
    const newsletterData = newsletter()
    if (newsletterData && newsletterData.update) {
      this._observers.push(newsletterData)
    }
  }

  notifyObservers (payload) {
    for (const observer of this._observers) {
      observer.update(payload)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    const email = this.input.value
    const variant_id = this.getAttribute('data-variant-id')
    const product_id = this.getAttribute('data-product-id')
    const shop_id = this.getAttribute('data-shop-id')
    const success_msg_type = this.getAttribute('data-success')
    const payload = {
      userEmail: email,
      variantID: variant_id,
      productID: product_id,
      shopID: shop_id
    }
    this.notifyObservers({ payload, e })
    this.end_point_url = `/a/app/back-in-stock/query`
    this.bis_mutation = `
      mutation CreateBackInStockRequest($input : NewBackInStockRequest!) {
        createBackInStockRequest(input: $input) {
          id
          expiresAt
          variant {
            id
            product {
              id
              shop {
                id
              }
            }
          }
        }
      }
    `

    if (validateEmail(email)) {
      this.btn_spinner.classList.remove('hidden')
      this.btn_label.classList.add('opacity-0')
      try {
        const response = await fetch(this.end_point_url, {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            query: this.bis_mutation,
            variables: { input: payload }
          })
        })
        if (response.ok) {
          if (success_msg_type === 'popup') {
            const dialog = e.target.closest('.bis__wrapper')
            if (dialog) {
              dialog.querySelector('dialog').showModal()
            }
            document.body.classList.add('overflow-hidden')
          } else {
            this.success_msg.classList.remove('hidden')
          }
          this.input.value = ''
        } else {
          this.server_error.classList.remove('hidden')
        }
      } catch (error) {
        this.server_error.classList.remove('hidden')
        console.error(error)
      } finally {
        this.btn_spinner.classList.add('hidden')
        this.btn_label.classList.remove('opacity-0')
      }
    } else {
      this.email_error.classList.remove('hidden')
    }
  }

  hideMessage () {
    this.email_error.classList.add('hidden')
    this.server_error.classList.add('hidden')
    this.success_msg.classList.add('hidden')
  }
}
if (!customElements.get('back-in-stock-form')) {
  customElements.define('back-in-stock-form', BackInStockForm)
}
